module.exports = __webpack_public_path__ + "cb8adc7b9f3a025a961c255243a6aac2.svg";